import { render, staticRenderFns } from "./PostProgramas.vue?vue&type=template&id=016bfd7e&scoped=true"
import script from "./PostProgramas.vue?vue&type=script&lang=js"
export * from "./PostProgramas.vue?vue&type=script&lang=js"
import style0 from "./PostProgramas.vue?vue&type=style&index=0&id=016bfd7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016bfd7e",
  null
  
)

export default component.exports